// Registers the moment locales of the supported interface languages
// (the date/time-ago pipes use moment). English is built in.
import 'moment/locale/fr';
import 'moment/locale/zh-cn';
import 'moment/locale/zh-tw';
import 'moment/locale/de';
import 'moment/locale/hi';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/ru';
import 'moment/locale/es';
import 'moment/locale/tr';
import 'moment/locale/ar';

/** Interface language code -> moment locale */
export function momentLocaleFor(code: string): string {
	return code === 'en-US' ? 'en' : code.toLowerCase().startsWith('zh') ? code.toLowerCase() : code.split('-')[0];
}
